import React from 'react';
import { StyleSheet } from 'react-native';
import LinkStyleButton from './LinkStyleButton';
import FontSizes from '../../constants/FontSizes';
import { MainColors } from '../../constants/Colors';

const HeaderButton = (props) => {
    return (
        <LinkStyleButton
            style={props.disabled ? styles.disabledButton : styles.button}
            onPress={props.onPress}
            accessibilityLabel={props.accessibilityLabel}
            accessibilityHint={props.accessibilityHint}
            buttonText={props.buttonText}
            disabled={props.disabled}
        />
    )
}

const styles = StyleSheet.create({
    button: {
        color: 'white',
        fontSize: FontSizes.medium,
        marginRight: 15
    },
    disabledButton: {
        color: MainColors.mediumGray,
        fontSize: FontSizes.medium,
        marginRight: 15
    }
});

export default HeaderButton;